import React from 'react';
import Footer from './Footer';

import gal1 from '../img/gal (1).jpeg';
import gal2 from '../img/gal (2).jpeg';
import gal3 from '../img/gal (3).jpeg';
import gal4 from '../img/gal (4).jpeg';
import gal5 from '../img/gal (5).jpeg';
import gal6 from '../img/gal (6).jpeg';

const Gallery = () => {
  const images = [gal1, gal2, gal3, gal4, gal5, gal6];

  return (
    <div>
      <div class="breadcrumb">
                <a href="/">Home</a> Gallery
            </div>
      

      {/* Responsive Gallery */}
      <div className="container my-5">
        <div className="row">
          {images.map((image, index) => (
            <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
              <img
                src={image}
                alt={`Gallery ${index + 1}`}
                className="img-fluid rounded shadow-sm"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Gallery;
